import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import "./Name.linaria.module.css!=!./Name?./Name.linaria.module.css?css=H4sIAAAAAAAAA1WMSwqDMBQA956kXSQYtTTEw4RoPn00P+LDaoN3Lxa66HKYYajCIB1I0Nm6oQZVHETRjkdDTzMvkseeddM/VZsikpcB90AxJa9//d1LPsT1GeqcfCpiVeVCSC4QVNkJmg2vZ7qwnUGPa81Ka4iOeGNR8LyN3/ECbyNayll3KyaMR/MBvEVi4aYAAAA="
interface INameProps {
  text?: string;
  color?: string;
  className?: any;
  onClick?(e?: any): any;
}
const rootStyles = "atm_gi_idpfg4 atm_cs_8n312b atm_7l_84nvkm";
const Name = (props: INameProps) => {
  const {
    color,
    text = 'Untitled',
    className,
    onClick
  } = props;
  const colorStyle = color ? {
    color
  } : null;
  return <h6 onClick={onClick} style={colorStyle} data-testid="ModelName" className={cx(rootStyles, className)}>
            {text}
        </h6>;
};
const _exp2 = () => Name;
export const StyledName = /*#__PURE__*/styled(_exp2())({
  name: "StyledName",
  class: "s1y1i3tv",
  propsAsIs: true
});
export default Name;